import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

import { TrackingEvents, TrackingPayload } from '../core.types';

export enum PreferencesDrawerClosedReason {
    Backdrop = 'Backdrop',
    CloseButton = 'Close Button',
    Escape = 'Escape',
    External = 'External',
    ViewResults = 'View Results',
}

type TrackPreferencesFiltersDrawerClosedPayload = TrackingPayload & {
    reason: PreferencesDrawerClosedReason;
};

export const trackPreferencesFiltersDrawerClosedAnalytics = (payload: TrackPreferencesFiltersDrawerClosedPayload) => {
    track(TrackingEvents.SearchPage.PreferencesFiltersDrawerClosed, payload);
};

export const useTrackPreferencesFiltersDrawerClosed = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ reason }: Omit<TrackPreferencesFiltersDrawerClosedPayload, 'pageName' | 'url'>) => {
            return trackPreferencesFiltersDrawerClosedAnalytics({
                pageName: getAmplitudePageNameFromPath(pathname),
                reason,
                url,
            });
        },
        [pathname, url]
    );
};
